<form class="grid" [formGroup]="form">
  <mat-form-field>
    <mat-label>{{ 'SCHEDULE.hour' | translate }}</mat-label>
    <input formControlName="hour" type="number" max="23" min="0" matInput>
    @if (form.controls.hour.hasError('required')) {
      <mat-error>{{ 'SCHEDULE.hour_required' | translate }}</mat-error>
    }
    @if (form.controls.hour.hasError('max')) {
      <mat-error>{{ 'SCHEDULE.hour_range' | translate }}</mat-error>
    }
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'SCHEDULE.minute' | translate }}</mat-label>
    <input formControlName="minute" type="number" max="59" min="0" matInput>
    @if (form.controls.minute.hasError('required')) {
      <mat-error>{{ 'SCHEDULE.minute_required' | translate }}</mat-error>
    }
    @if (form.controls.minute.hasError('max')) {
      <mat-error>{{ 'SCHEDULE.minute_range' | translate }}</mat-error>
    }
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'SCHEDULE.weekdays' | translate }}</mat-label>
    <mat-select formControlName="days" multiple>
      @for (day of days; track day) {
        <mat-option [value]="day">
          {{ day | label: 'days-of-week' | async }}
        </mat-option>
      }
    </mat-select>
    <mat-error>{{ 'SCHEDULE.days_required' | translate }}</mat-error>
  </mat-form-field>

  <app-button-group alignment="flex-end">
    <button [disabled]="form.invalid" [mat-dialog-close]="form.value" mat-stroked-button color="primary">
      <mat-icon>check</mat-icon>
      <mat-label>{{ 'COMMON.save' | translate }}</mat-label>
    </button>
  </app-button-group>
</form>
